import { render } from "./ContactModal.vue?vue&type=template&id=606a826a&scoped=true"
import script from "./ContactModal.vue?vue&type=script&lang=ts"
export * from "./ContactModal.vue?vue&type=script&lang=ts"

import "./ContactModal.vue?vue&type=style&index=0&id=606a826a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-606a826a"

export default script